<template>
      <div class="w-full bg-gray-800 bg-no-repeat flex flex-col justify-start" style="
                  background-blend-mode: multiply;
                  background-position: center center;
                  background-size: contain;
                  background-image: url('/img/PBC_Meme.svg');
                  "
                  >

        <div class="grow flex flex-col justify-center mb-">
          <div class="p-10 py-3 flex flex-col flex-wrap justify-center content-center">
            <div class="z-60 mt-4">
              <h1 class="text-white font-bold text-2xl mb-2">Want more animated and interactive memes?</h1>
              <h1 class="text-white text-xl">Get the latest memes by</h1>
              <h2 class="text-blue-300 font-bold text-2xl -mt-3">installing to your device.</h2>
            </div>
          </div>

          <pbc-button class="mt-4 px-3 py-2 self-center w-32 flex-none text-white bg-green-400" @click='onAddApp'>
            <plus-circle-outline class="mr-2" :size='32' />
            <span class="mr-2 text-lg">Install</span>
          </pbc-button>
        </div>
      </div>

</template>
<script>
import PlusCircleOutline from '@icons/PlusCircleOutline.vue';
export default {
  data() {
    return {
    }
  },
  components:{
    PlusCircleOutline,
  },
  methods: {
    onAddApp() {
      this.$eventbus.emit("installApp");
      this.$eventbus.emit("installNotifications");
      this.$emit("close");
    },
  },
  watch: {
  }
}
</script>
<style scoped>
.content-rotate {
transform: rotate(-7deg);
overflow: hidden;
}
</style>
